/* ck-line-art — draws the hand-drawn line illustrations on, like a pen.

   How it works: the artwork is a single traced path made of several closed
   contours. We clone each contour into a <mask> as a stroked line the width of
   a pen nib, then run stroke-dashoffset along it. The nib reveals the real
   artwork underneath — the drawing is never redrawn or approximated. Contours
   are timed by their true length so a long sweep takes longer than a short
   tick, which is what makes it read as a hand rather than a wipe.

   Nib width matters: at 6 the pen tracks the original line weight. Wider and it
   bleeds into the enclosed shapes and fills them solid. */

(function () {
  var NS = 'http://www.w3.org/2000/svg';
  var DURATION = 2200;
  var uid = 0;

  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function subpaths(d) {
    return d.split(/(?=M)/).filter(function (s) { return s.trim().length > 3; });
  }

  function build(svg) {
    var art = svg.querySelector('.ck-line__art');
    if (!art) return null;

    var nib = parseFloat(svg.getAttribute('data-nib')) || 6;
    var segs = subpaths(art.getAttribute('d'));
    if (segs.length === 0) return null;

    svg.classList.add('ck-line--pending');

    // Measure each contour before committing to the mask.
    var probe = document.createElementNS(NS, 'path');
    svg.appendChild(probe);
    var lens = segs.map(function (d) {
      probe.setAttribute('d', d);
      return probe.getTotalLength();
    });
    svg.removeChild(probe);

    var total = lens.reduce(function (a, b) { return a + b; }, 0);
    if (!total) { svg.classList.remove('ck-line--pending'); return null; }

    var defs = document.createElementNS(NS, 'defs');
    var mask = document.createElementNS(NS, 'mask');
    var id = 'ck-line-mask-' + (++uid);
    mask.setAttribute('id', id);

    var pens = [];
    var acc = 0;
    segs.forEach(function (d, i) {
      var pen = document.createElementNS(NS, 'path');
      pen.setAttribute('d', d);
      pen.setAttribute('fill', 'none');
      pen.setAttribute('stroke', '#fff');
      pen.setAttribute('stroke-width', nib);
      pen.setAttribute('stroke-linecap', 'round');
      pen.setAttribute('stroke-linejoin', 'round');
      pen.style.strokeDasharray = lens[i];
      pen.style.strokeDashoffset = lens[i];
      pens.push({ el: pen, len: lens[i], delay: DURATION * (acc / total), dur: DURATION * (lens[i] / total) });
      acc += lens[i];
      mask.appendChild(pen);
    });

    defs.appendChild(mask);
    svg.insertBefore(defs, svg.firstChild);
    art.setAttribute('mask', 'url(#' + id + ')');

    svg.classList.remove('ck-line--pending');
    svg.classList.add('ck-line--ready');

    return function play() {
      var base = parseFloat(svg.getAttribute('data-ck-line-delay')) || 0;
      pens.forEach(function (p) {
        p.el.animate(
          [{ strokeDashoffset: p.len }, { strokeDashoffset: 0 }],
          { duration: p.dur, delay: base + p.delay, fill: 'forwards', easing: 'linear' }
        );
      });
    };
  }

  function init() {
    var nodes = document.querySelectorAll('[data-ck-line]');
    if (!nodes.length) return;

    // Reduced motion, or no IntersectionObserver: leave the artwork complete.
    if (reduced() || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var play = entry.target.__ckLinePlay;
        if (play) play();
        io.unobserve(entry.target);
      });
    }, { threshold: 0.35 });

    nodes.forEach(function (svg) {
      if (svg.__ckLineDone) return;
      svg.__ckLineDone = true;
      var play = build(svg);
      if (!play) return;
      svg.__ckLinePlay = play;
      io.observe(svg);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Shopify theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', init);
})();
